var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetinga(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.066,
    height: 21.425,
    viewBox: "0 0 122.066 21.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.223 -13.826)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.614 16.904)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M87.612,135.239v5.5H84.826v-4.905a1.491,1.491,0,0,0-1.473-1.629c-1.032,0-1.715.754-1.715,2.225v4.309h-2.8v-4.905a1.5,1.5,0,0,0-1.489-1.629c-1.017,0-1.681.754-1.681,2.225v4.309h-2.8v-8.794h2.8v.807a3.326,3.326,0,0,1,2.592-1.069,3.256,3.256,0,0,1,2.871,1.488,3.8,3.8,0,0,1,3.12-1.488A3.349,3.349,0,0,1,87.612,135.239Z",
    transform: "translate(-72.862 -127.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M96.729,137.061H90.284a2.031,2.031,0,0,0,3.766.684l2.487.509A4.369,4.369,0,0,1,92.175,141a4.659,4.659,0,0,1,.018-9.319,4.458,4.458,0,0,1,4.536,4.659Zm-6.393-1.716h3.625a1.756,1.756,0,0,0-1.769-1.383A1.925,1.925,0,0,0,90.336,135.344Z",
    transform: "translate(-71.454 -127.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M105.917,137.061H99.472a2.032,2.032,0,0,0,3.767.684l2.486.509a4.369,4.369,0,0,1-4.36,2.75,4.659,4.659,0,0,1,.018-9.319,4.457,4.457,0,0,1,4.535,4.659Zm-6.392-1.716h3.624a1.754,1.754,0,0,0-1.768-1.383A1.923,1.923,0,0,0,99.525,135.344Z",
    transform: "translate(-70.573 -127.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M113.042,140.558a4.779,4.779,0,0,1-2.4.649,3.168,3.168,0,0,1-3.506-3.5v-3.328h-1.592V132.15h1.592v-2.592h2.8v2.592h2.592v2.225h-2.592v3.049c0,.911.438,1.278,1.174,1.278a2.86,2.86,0,0,0,1.279-.35Z",
    transform: "translate(-69.726 -127.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M116.538,129.7a1.549,1.549,0,0,1-1.631,1.558A1.531,1.531,0,0,1,113.3,129.7a1.58,1.58,0,0,1,1.611-1.595A1.6,1.6,0,0,1,116.538,129.7Zm-3.031,11.386V132.29h2.8v8.794Z",
    transform: "translate(-68.982 -128.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M126.943,135.344v5.4h-2.785v-4.8a1.551,1.551,0,0,0-1.507-1.734c-1.1,0-1.821.754-1.821,2.453v4.081h-2.8v-8.794h2.8v.841a3.626,3.626,0,0,1,2.7-1.1A3.344,3.344,0,0,1,126.943,135.344Z",
    transform: "translate(-68.528 -127.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M137.008,139.864c0,2.715-2.067,4.2-4.923,4.2a4.8,4.8,0,0,1-4.413-2.12l2.33-1.26a2.387,2.387,0,0,0,2.068,1.085,2.009,2.009,0,0,0,2.189-2.137v-.245a3.923,3.923,0,0,1-2.646.841,4.274,4.274,0,0,1,0-8.547,3.923,3.923,0,0,1,2.646.841v-.579h2.75Zm-2.75-3.941a2.077,2.077,0,1,0-2.049,2.014A1.986,1.986,0,0,0,134.259,135.923Z",
    transform: "translate(-67.632 -127.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M147.334,140.74h-2.8v-.7A3.958,3.958,0,0,1,141.8,141a4.675,4.675,0,0,1,0-9.319,3.953,3.953,0,0,1,2.732.963v-.7h2.8Zm-2.8-4.4a2.195,2.195,0,0,0-2.154-2.277,2.283,2.283,0,0,0,0,4.555A2.183,2.183,0,0,0,144.531,136.343Z",
    transform: "translate(-66.659 -127.759)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.223 13.826)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M81.652,88.256a5.558,5.558,0,0,0,1.474,5.3l11.516,10.2c1.5,1.238,2.9,1.255,4.246.01L110.452,93.52a5.53,5.53,0,0,0,1.438-5.264,6.034,6.034,0,0,0-4.32-4.264A5.013,5.013,0,0,0,102.6,85.3l-5.83,5.771-5.828-5.768a5.085,5.085,0,0,0-4.97-1.314A6.032,6.032,0,0,0,81.652,88.256Z",
    transform: "translate(-81.383 -83.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M118.685,112.908a7.058,7.058,0,0,0,4.266,1.43c3.883,0,6.647-9.472,5.994-10.522Z",
    transform: "translate(-98.331 -92.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-meetinga",
    d: "M91.654,112.908a7.058,7.058,0,0,1-4.266,1.43c-3.883,0-6.647-9.472-5.994-10.522Z",
    transform: "translate(-81.297 -92.912)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetinga);
export default __webpack_public_path__ + "static/media/meetinga.c6fe0db8.svg";
export { ForwardRef as ReactComponent };